/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MaskRadial({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M1 13.3v.2a1 1 0 0 0 1 1m13-1.2v.2a1 1 0 0 1-1 1m-9.5 0h2m3 0h2M1 11.3V9.5m14 1.8V9.5" /><path stroke="currentColor" strokeWidth={1.2} d="M15 6.5c0 2.761-3.134 5-7 5s-7-2.239-7-5" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="m7.5 11.5 1.797-2.825a2 2 0 0 1 3.384.014l.563.902M1 6.5v-3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3" /><circle cx={6} cy={5.5} r={2} stroke="currentColor" strokeWidth={1.2} /></svg>;
}
;